import { render, staticRenderFns } from "./SubscriptionUnsubscribeListDialog.vue?vue&type=template&id=24b47ad1&"
import script from "./SubscriptionUnsubscribeListDialog.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionUnsubscribeListDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
